import CardPlayFeed from './CardPlayFeed';

export default CardPlayFeed;
